<template>
  <g>
    <g 
      v-for="spot in centerSpots"
      :key="spot.id">
      <visualization-contour-spot
        :spot="spot"
        :layer-type="'light'"
      />
    </g>

    <!-- NOTE: Image mask for thing -->
    <map-mask-image />

    <!-- NOTE: Contour spot for thing -->
    <g 
      v-for="spot in individualSpots"
      :key="spot.id">
      <visualization-contour-spot
        :spot="spot"
        :layer-type="'light'"
      />
    </g>
  </g>
</template>

<script>
import config from '@/config.js';
import map from '@/mixins/map.js';
import mapMaskImage from '@/components/map/map_mask_image.vue';
import visualizationContour from '@/components/map/visualization/partials/contours.vue';
import visualizationContourSpot from '@/components/map/visualization/partials/contours_spot.vue';

export default {
  components: {
    mapMaskImage,
    visualizationContour,
    visualizationContourSpot,
  },
  mixins: [map],
  computed: {
    spots: ({ $store }) => $store.getters['area/spotAll'],
    lightSpots: (vm) => vm.spots.filter((spot) => vm.isPrivateSpot(spot)),
    centerSpots: (vm) => vm.lightSpots.filter((spot) => vm.isCenterSpot(spot.tags || [])),
    individualSpots: (vm) => vm.lightSpots.filter((spot) => vm.isIndividualSpot(spot.tags || [])),
    lightVisualizationConfig:() => config.visualizationHeaders['light'],
    lightMinValue: (vm) => vm.lightVisualizationConfig.minValue,
    lightMaxValue: (vm) => vm.lightVisualizationConfig.maxValue,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getLightThings();
      this.$store.commit('visualization/setMinValue', { layerType: 'light', value: this.lightMinValue });
      this.$store.commit('visualization/setMaxValue', { layerType: 'light', value: this.lightMaxValue });
      this.$store.commit('visualization/setLineInterval', { layerType: 'light', value: 40 });
    },
    async getLightThings() {
      await this.$store.dispatch('visualization/getLightThings');
    },
  },
};
</script>



// WEBPACK FOOTER //
// light.vue?c183a2d2